import { Label } from "expano-components";
import { Button, MainList, Main } from "components";

import { ReactComponent as PlatformIcon } from "icons/platform.svg";
import {getLanguageName} from 'utils/select_options/available_languages'
import { sort, filters } from "./const/data";

const PlatformsList = ({ history }) => (
  <Main
    page={{
      name: "Platformy",
      icon: <PlatformIcon />,
      breadcrumbs: [
        {
          name: "Platformy",
        },
      ],
      buttons: (
        <Button type="add" text="Dodaj platformę" path="/platforms/new" />
      ),
    }}
  >
    <MainList
      query_key="platforms"
      api_path="/platforms"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/platforms/${item.id}`)}
      renderItem={({
        id,
        name,
        country_code,
        currency_code,
        language,
        offer_title_max_length,
        label_text,
        label_color,
        shops,
      }) => (
        <>
          <td>{id}</td>
          <td>{name}</td>
          <td>
            <Label text={label_text} type="bordered" color={label_color} />
          </td>
          <td>{country_code}</td>
          <td>{currency_code}</td>
          <td>{getLanguageName(language)}</td>
          <td>{offer_title_max_length}</td>
          <td>
            {shops
              .sort((a, b) => a.id - b.id)
              .map(({ id, label_text, label_color }) => (
                <Label
                  key={id}
                  text={label_text}
                  type="fill"
                  color={label_color}
                />
              ))}
          </td>
        </>
      )}
    />
  </Main>
);

export default PlatformsList;
